import {
  PERSONA_TYPE_LABELS, PERSONA_COLORS,
} from '../api/projects';
import type { PersonaType } from '../api/projects';

interface PersonaAvatarProps {
  persona: PersonaType | undefined;
  roleName: string;
  size?: 56 | 40;
  showBadge?: boolean;
}

export function PersonaAvatar({
  persona, roleName, size = 56, showBadge = true,
}: PersonaAvatarProps) {
  const label = persona ? PERSONA_TYPE_LABELS[persona] : null;
  const palette = persona ? PERSONA_COLORS[persona] : null;
  const emoji = label?.icon ?? '👤';
  const typeLabel = label?.label ?? 'Bilinmiyor';
  const fontSize = size === 56 ? '2rem' : '1.4rem';

  return (
    <div className="persona-avatar" data-persona={persona ?? 'unknown'}>
      <div
        className="persona-avatar-circle"
        style={{
          width: size, height: size,
          background: palette?.bg ?? '#f1f5f9',
          borderColor: palette?.fg ?? '#94a3b8',
          fontSize,
        }}
        aria-hidden="true"
      >
        {emoji}
      </div>
      {showBadge && (
        <span
          className="persona-avatar-badge"
          style={{
            color: palette?.fg ?? 'var(--text-muted)',
            borderColor: palette?.fg ?? 'var(--border)',
          }}
        >
          {typeLabel}
        </span>
      )}
      <span className="visually-hidden">{roleName} ({typeLabel})</span>
    </div>
  );
}